import { HistoricalMedicalLeave } from '@dreryk/egabinet-ezla-frontend-api';

import { EmptyStatePlaceholder } from '@dreryk/react-components';

import { historicalLeavesTranslationKeys } from '../../../translations';

import { useHistoricalLeavesTableDataConfiguration, useHistoricalLeaveTableColumns } from './historicalLeaves.hooks';
import { StyledHistoricalLeavesTable } from './HistoricalLeaves.styled';

type HistoricalLeavesProps = {
   readonly patientId: number | undefined;
};

export const HistoricalLeaves = (props: HistoricalLeavesProps): JSX.Element => {
   const columns = useHistoricalLeaveTableColumns();
   const dataConfiguration = useHistoricalLeavesTableDataConfiguration(props.patientId);

   return (
      <StyledHistoricalLeavesTable<HistoricalMedicalLeave>
         columns={columns}
         dataConfiguration={dataConfiguration}
         keyExtractor={'copyId'}
         testId='historicalLeaves'
         placeholder={
            <EmptyStatePlaceholder
               heading={historicalLeavesTranslationKeys.noHistoricalLeaves}
               subheading={historicalLeavesTranslationKeys.goToEzlaForm}
               testId={'noHistoricalLeaves'}
            />
         }
      />
   );
};
